import IconBadge from 'flow/components/ui-components/IconBadge';
import useAppContext from 'flow/hooks/useAppContext';
import React from 'react';

const Verified = ({ state }: { state: string }) => {
    const { i18next } = useAppContext();

    if (state === 'validated') {
        return (
            <div className="flex items-center gap-x-2 text-xs">
                <IconBadge iconKey="done" size="0.5rem" className="p-1" />
                <p>{i18next.t('settings.user.credential.verified')}</p>
            </div>
        );
    }

    return (
        <div className="flex items-center gap-x-2 text-xs">
            <div className="flex size-4 items-center justify-center rounded-sm bg-gray-200" />
            <p className="whitespace-nowrap">
                {i18next.t('settings.user.credential.not_verified')}
            </p>
        </div>
    );
};

export default Verified;
